// Kindra utility — class merger + leak colour map
export const cn = (...args) => args.filter(Boolean).join(' ');

export const LEAK_META = {
  time:      { name: 'Time',       color: '#EB258D', cssVar: 'var(--leak-time)',      tw: 'leak-time' },
  money:     { name: 'Money',      color: '#9156C4', cssVar: 'var(--leak-money)',     tw: 'leak-money' },
  lostwork:  { name: 'Lost-Work',  color: '#4F8FD0', cssVar: 'var(--leak-lostwork)',  tw: 'leak-lostwork' },
  pricing:   { name: 'Pricing',    color: '#1FB6C1', cssVar: 'var(--leak-pricing)',   tw: 'leak-pricing' },
  blindspot: { name: 'Blind-Spot', color: '#34D1B0', cssVar: 'var(--leak-blindspot)', tw: 'leak-blindspot' },
};

export const LEAK_ORDER = ['time', 'money', 'lostwork', 'pricing', 'blindspot'];

export const severityFor = (score) => {
  if (score >= 60) return { key: 'sealed', label: 'Sealed', color: '#1FB6C1' };
  if (score >= 35) return { key: 'leaking', label: 'Leaking', color: '#9156C4' };
  return { key: 'gushing', label: 'Gushing', color: '#EB258D' };
};
